import { ReactNode, FC } from 'react';
import { Grid2 as Grid, Typography, CircularProgress } from '@mui/material';

interface ProjectHeatmapBlockHeaderProps {
  heatmapFilters: ReactNode;
  title: string;
  loading?: boolean;
}

const ProjectHeatmapBlockHeader: FC<ProjectHeatmapBlockHeaderProps> = ({ heatmapFilters, title, loading }) => (
  <Grid container direction="row" justifyContent="space-between" alignItems="center" width="100%">
    <Grid size={2.4} display="flex" alignItems="center" gap={1}>
      <Typography variant="h4" color="primary">
        {title}
      </Typography>

      {loading && <CircularProgress size={16} />}
    </Grid>

    <Grid size="auto" alignItems="center" sx={{ '.filter-item-wrapper': { mb: 0 }, '.filters-reset-btn': { mb: 0 } }}>
      {heatmapFilters}
    </Grid>

    <Grid size="grow" />
  </Grid>
);

export default ProjectHeatmapBlockHeader;
